import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import { Match, Switch, type VoidComponent } from "solid-js";
import type { ZodIssue } from "zod";
import { ErrorRow } from "./styled";

const ErrorMessage: VoidComponent<{ error: ZodIssue }> = (props) => {
	const { t } = useI18n();

	const getRangeLabel = () => {
		switch (props.error.code) {
			case "too_big":
				return t(`errors.max.${props.error.type}`, Number(props.error.maximum));
			case "too_small":
				return t(`errors.min.${props.error.type}`, Number(props.error.minimum));
			default:
				return "";
		}
	};

	const getTypeLabel = () => (props.error.code === "invalid_type" ? t("errors.type", props.error.expected) : "");

	const getStringLabel = () =>
		props.error.code === "invalid_string" ? t("errors.string", props.error.validation) : "";

	return (
		<ErrorRow>
			<Switch fallback={t(props.error.message as Parameters<typeof t>[0])?.toString()}>
				<Match when={props.error.code === "too_big" || props.error.code === "too_small"}>{getRangeLabel()}</Match>
				<Match when={props.error.code === "invalid_type"}>{getTypeLabel()}</Match>
				<Match when={props.error.code === "invalid_string"}>{getStringLabel()}</Match>
			</Switch>
		</ErrorRow>
	);
};
export default ErrorMessage;
